/* CellCare — carrousel, barre d'achat fixe, variantes, guide de choix. Sans dépendance. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Galerie : défilement par ancrage, compteur, vignettes, flèches. */
  document.querySelectorAll('[data-cc-gallery]').forEach((gal) => {
    const track = gal.querySelector('.cc-gallery__track');
    const slides = [...gal.querySelectorAll('.cc-gallery__slide')];
    const current = gal.querySelector('[data-current]');
    const thumbs = [...gal.querySelectorAll('[data-go]')];
    if (!track || slides.length < 2) return;
    const go = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    };
    const active = () => Math.round(track.scrollLeft / track.clientWidth);
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = active();
        if (current) current.textContent = i + 1;
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      });
    }, { passive: true });
    gal.querySelector('[data-prev]')?.addEventListener('click', () => go(active() - 1));
    gal.querySelector('[data-next]')?.addEventListener('click', () => go(active() + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.go))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active() - 1); }
    });
  });

  /* Barre d'achat fixe (mobile) : visible quand le bouton principal sort de l'écran. */
  const bar = document.querySelector('[data-cc-stickybar]');
  const add = document.querySelector('[data-cc-add]');
  if (bar && add && 'IntersectionObserver' in window) {
    bar.hidden = false;
    // Visible dès l'arrivée (bouton principal sous le premier écran) et après l'avoir dépassé ; masquée quand il est à l'écran.
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('cc-has-stickybar', show);
    });
    io.observe(add);
  }

  /* Variantes en pastilles (si le produit en a plusieurs). */
  document.querySelectorAll('[data-cc-variants-picker]').forEach((picker) => {
    const data = JSON.parse(picker.querySelector('[data-cc-variants-json]')?.textContent || '[]');
    const section = picker.closest('.cc-product');
    const idInput = section?.querySelector('[data-cc-variant-id]');
    const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    picker.addEventListener('change', () => {
      const values = [...picker.querySelectorAll('[data-cc-option]:checked')].map((i) => i.value);
      picker.querySelectorAll('[data-cc-option-label]').forEach((l, i) => { l.textContent = values[i] || ''; });
      const v = data.find((x) => x.options.every((o, i) => o === values[i]));
      if (!v || !idInput) return;
      idInput.value = v.id;
      section.querySelectorAll('[data-cc-price]').forEach((p) => { p.textContent = money(v.price); });
      section.querySelectorAll('button[type="submit"]').forEach((b) => { b.disabled = !v.available; });
      const stock = section.querySelector('[data-cc-stock]');
      if (stock) stock.hidden = v.available;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

})();

/* Bannière cookies : le choix est transmis à l'API de consentement Shopify. */
(() => {
  const box = document.getElementById('CcCookie');
  if (!box) return;
  const KEY = 'cc_consent_v1';
  const store = (val) => { try { if (val === undefined) return localStorage.getItem(KEY); localStorage.setItem(KEY, val); } catch (e) { return null; } return null; };
  const prefs = box.querySelector('#CcCookiePrefs');
  const more = box.querySelector('[data-cc-cookie="custom"]');
  const saveBtn = box.querySelector('[data-cc-cookie="save"]');
  const pref = (name) => box.querySelector(`[data-cc-pref="${name}"]`);

  const withApi = (cb) => {
    const sh = window.Shopify;
    if (sh && sh.customerPrivacy) return cb(sh.customerPrivacy);
    if (sh && typeof sh.loadFeatures === 'function') {
      sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => cb(!err && sh.customerPrivacy ? sh.customerPrivacy : null));
    } else cb(null);
  };

  const showPrefs = () => {
    prefs.hidden = false;
    saveBtn.hidden = false;
    more.setAttribute('aria-expanded', 'true');
  };
  const open = (withPrefs) => {
    box.hidden = false;
    requestAnimationFrame(() => box.classList.add('is-open'));
    if (withPrefs) {
      showPrefs();
      box.querySelector('#CcCookieTitle').focus({ preventScroll: true });
    }
  };
  const close = () => {
    box.classList.remove('is-open');
    setTimeout(() => { box.hidden = true; }, 260);
  };
  const save = (c) => {
    store(JSON.stringify({ ...c, date: new Date().toISOString() }));
    ['analytics', 'marketing', 'preferences'].forEach((k) => { pref(k).checked = c[k]; });
    withApi((cp) => {
      if (cp) cp.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, () => {});
    });
    close();
  };

  withApi((cp) => {
    let decided = false;
    const saved = store();
    if (saved) {
      try {
        const s = JSON.parse(saved);
        ['analytics', 'marketing', 'preferences'].forEach((k) => { pref(k).checked = !!s[k]; });
        decided = Date.now() - new Date(s.date).getTime() < 365 * 864e5;
      } catch (e) { decided = false; }
    }
    if (cp && typeof cp.currentVisitorConsent === 'function') {
      const v = cp.currentVisitorConsent() || {};
      if (v.analytics || v.marketing || v.preferences) {
        decided = true;
        ['analytics', 'marketing', 'preferences'].forEach((k) => { if (v[k]) pref(k).checked = v[k] === 'yes'; });
      }
    }
    if (!decided) open(false);
  });

  box.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cc-cookie]');
    if (!b) return;
    const a = b.dataset.ccCookie;
    if (a === 'accept') save({ analytics: true, marketing: true, preferences: true });
    else if (a === 'refuse') save({ analytics: false, marketing: false, preferences: false });
    else if (a === 'custom') showPrefs();
    else if (a === 'save') save({ analytics: pref('analytics').checked, marketing: pref('marketing').checked, preferences: pref('preferences').checked });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-cc-cookie-open]')) return;
    e.preventDefault();
    open(true);
  });
})();

/* v2 — Cartes « allumées » au centre de l'écran, raccourcis actifs, colonnes du footer. */
(() => {
  const cards = document.querySelectorAll('.cc2-pcard__media.has-lit');
  if (cards.length && 'IntersectionObserver' in window && !matchMedia('(hover: hover)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => en.target.classList.toggle('is-lit', en.intersectionRatio > 0.75));
    }, { threshold: [0, 0.75, 1] });
    cards.forEach((c) => io.observe(c));
  }

  const nav = document.querySelector('.cc2-anchors');
  if (nav && 'IntersectionObserver' in window) {
    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const targets = links.map((a) => document.querySelector(a.getAttribute('href'))).filter(Boolean);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        links.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === `#${en.target.id}`));
        const act = nav.querySelector('.is-active');
        // défilement horizontal de la barre seulement : scrollIntoView ramenait la page vers la barre et bloquait le défilement
        const sc = act && act.closest('ul, ol, nav');
        if (sc && sc.scrollWidth > sc.clientWidth) { const r = act.getBoundingClientRect(), q = sc.getBoundingClientRect(); sc.scrollTo({ left: sc.scrollLeft + r.left - q.left - (q.width - r.width) / 2, behavior: 'smooth' }); }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    targets.forEach((t) => io.observe(t));
    links.forEach((a) => a.addEventListener('click', () => {
      const t = document.querySelector(a.getAttribute('href'));
      if (t && t.tagName === 'DETAILS') t.open = true;
    }));
  }
})();

/* v2 — hauteur réelle de l'en-tête collant, pour placer les barres collantes juste dessous. */
(() => {
  const h = document.querySelector('.section-header');
  if (!h) return;
  const set = () => {
    document.documentElement.style.setProperty('--cc-header-h', `${Math.round(h.getBoundingClientRect().height)}px`);
    // hauteur totale au-dessus du contenu (bandeau + en-tête + raccourcis) : le hero clair remplit le reste du premier écran
    const main = document.querySelector('main');
    if (main) document.documentElement.style.setProperty('--cc-stack-h', `${Math.round(main.getBoundingClientRect().top + scrollY)}px`);
  };
  set();
  window.addEventListener('resize', set, { passive: true });
})();

/* Footer : colonnes en accordéon sur mobile, ouvertes en desktop. Tableaux comparatifs : indice de défilement. */
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  const cols = [...document.querySelectorAll('[data-cc-footcol]')];
  const sync = () => cols.forEach((d) => { d.open = mq.matches; });
  sync();
  mq.addEventListener?.('change', sync);
  document.querySelectorAll('[data-cc-cmp]').forEach((c) => {
    const sc = c.querySelector('.cc-cmp__scroll');
    const upd = () => {
      c.classList.toggle('is-scrollable', sc.scrollWidth > sc.clientWidth + 4);
      c.classList.toggle('is-end', sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4);
    };
    upd();
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
  });
})();

/* Liens « Ce qui est inclus », « Précautions » : ouvrent l'accordéon visé. */
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[data-cc-open]');
  if (!a) return;
  const t = document.querySelector(a.getAttribute('href'));
  if (t && t.tagName === 'DETAILS') t.open = true;
});
